import { generatePath } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { CryptocurrencyConversionStepUi } from "@src/widgets/onboarding/ui/tours/Exchange/CryptocurrencyConversionStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class CryptocurrencyConversionStep extends TourStepBase {
  component = CryptocurrencyConversionStepUi
  name = `${ONBOARDING_TOURS.EXCHANGE}_CryptocurrencyConversion`

  constructor() {
    super({
      highlightElements: ["GENERATED_ID_CONVERTFORM_FORM_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM_LEFT,
    })
  }

  action() {
    return router.navigate({
      pathname: generatePath(paths.swap),
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "Effortlessly exchange cryptocurrencies",
      title: "Cryptocurrency Swap",
    }
  }
}
